// Chat Challenge conversation flows for all 8 conversation types

export const getChatChallengeFlow = (conversationNum, studentName, friendName) => {
    const flows = {
        // 0: Favorite Things - Animal
        0: [
            {
                text: `${friendName} says, \"We are going to talk about our favorite animal.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} greets ${studentName}.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} greet you?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet me.\"",
            },
            {
                text: `${friendName} asks, \"What is your favorite animal?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} answer your question?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: `${friendName} responds to ${studentName}'s answer.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} ask you a question about your favorite animal?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask me a question.\"",
            },
            {
                text: `${friendName} answers ${studentName}'s question.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} respond to your answer?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond to my answer.\"",
            },
            {
                text: `${friendName} closes the conversation with ${studentName}.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} close the conversation?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to close the conversation.\"",
            },
            {
                text: `${friendName} says, “Good job! You completed the Chat Challenge!”`,
                type: "instruction",
                sender: "friend"
            }
        ],

        // 1: Talk about Feelings
        1: [
            {
                text: `${friendName} says, \"We are going to talk about what makes you feel confident.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} asks, \"What makes you feel confident?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} answer your question? (I feel confident when_____.)`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: `${friendName} says, \"I'm glad that makes you feel confident when ______.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} thank you?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to thank me.\"",
            },
            {
                text: `${friendName} says, “Good job! You completed the Chat Challenge!”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Now show ${studentName} the screen to get their final score.`,
                type: "instruction",
                sender: "friend"
            }
        ],

        // 2: Active Listening
        2: [
            {
                text: `${friendName} says, \"We are going to talk about what makes me feel calm.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} asks, \"Ask me what makes me feel calm.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} ask, "What makes you feel calm?"`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask me a question.\"",
            },
            {
                text: `${friendName} says, “I feel calm when ______.”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "I'm glad you feel calm when ______."?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to say, \"I’m glad you feel calm when ______.\"\"",
            },
            {
                text: `${friendName} says, “Thank you.”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} says, “Good job! You completed the Chat Challenge!”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Now show ${studentName} the screen to get their final score.`,
                type: "instruction",
                sender: "friend"
            }
        ],

        // 3: Making Friends
        3: [
            {
                text: `${friendName} says, \"We are going to talk about our favorite thing to do outside.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} asks, \"Greet me and ask me my name.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} greet you and ask your name?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet me and ask me a question.\"",
            },
            {
                text: `${friendName} greets ${studentName} and says your name.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} ask you, "What is your favorite thing to do outside?"`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask me a question about my favorite thing to do outside.\"",
            },
            {
                text: `${friendName} answers ${studentName}'s question.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} respond to your answer?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond to my answer.\"",
            },
            {
                text: `${friendName} asks, \"What is your favorite thing to do outside?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} answer your question?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: `${friendName} responds to ${studentName}'s answer.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} close the conversation?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to close the conversation.\"",
            },
            {
                text: `${friendName} closes the conversation with ${studentName}.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} says, “Good job making friends. Now let’s practice how to stop bullying.”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} says, “If someone is bullying you, what are the three steps to stop bullying?”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did they say, “Step 1: Tell the bully to stop. Step 2: Walk away and stay away. Step 3: Tell a safe adult.”",
                type: "question",
                sender: "friend",
                reminder: "Step 1: Tell the bully to stop. Step 2: Walk away and stay away. Step 3: Tell a safe adult.",
            },
            {
                text: `${friendName} says, “Good job! You completed the Chat Challenge!”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Now show ${studentName} the screen to get their final score.`,
                type: "instruction",
                sender: "friend"
            }
        ],

        // 4: Solutions
        4: [
            {
                text: `${friendName} says, \"We are going to talk about what makes you feel nervous.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} asks, \"What makes you feel nervous?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} answer your question? (I feel nervous when ______.)`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: `${friendName} says, \"I'm sorry you feel nervous when ______. Ask, \"What is a solution?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} answer your question?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
            },
            {
                text: `${friendName} responds to ${studentName}'s answer.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} says, “Good job! You completed the Chat Challenge!”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Now show ${studentName} the screen to get their final score.`,
                type: "instruction",
                sender: "friend"
            }
        ],

        // 5: Resolve Conflict
        5: [
            {
                text: `${friendName} says, “If I sat where you wanted to sit on the bus and it made you feel sad, how would you resolve the conflict? Tell me the first step.”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "Be Calm"?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"The first step is, 'Be Calm.'\"",
            },
            {
                text: `${friendName} asks, \"What is the second step to resolve conflict?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "Talk About It"?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"The second step is, 'Talk About It.'\"",
            },
            {
                text: `${friendName} says, “If I was sitting where you wanted to sit, how would you tell me how you feel?”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "I feel sad because _____."?`,
                type: "question",
                sender: "friend",
                reminder: "Say, “Remember to say, ‘I feel sad because ______.’”",
            },
            {
                text: `${friendName} asks, \"What is the third step to resolve conflict?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "Make It Better"?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"The third step is, 'Make It Better.'\"",
            },
            {
                text: `${friendName} asks, \"How can you make this situation better?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} tell you how they can make it better?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to tell me how to make the situation better.\"",
            },
            {
                text: `${friendName} says, “Good job! You completed the Chat Challenge!”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Now show ${studentName} the screen to get their final score.`,
                type: "instruction",
                sender: "friend"
            }
        ],

        // 6: Self-Advocacy
        6: [
            {
                text: `${friendName} says, \"If you are at the snack shack and need a napkin, what is the first step to self-advocate?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "Think About What You Want to Say"?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"The first step is, 'Think About What You Want to Say.'\"",
            },
            {
                text: `${friendName} asks, \"What is the second step to self-advocate?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "Believe in Yourself"?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"The second step is, 'Believe in Yourself.'\"",
            },
            {
                text: `${friendName} asks, \"Can you sing or say the Joyful Jingle?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} sing or say the Joyful Jingle?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Let's sing or say the Joyful Jingle together!\"",
            },
            {
                text: `${friendName} asks, \"What is the third step to self-advocate?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "Achieve It"?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"The third step is, 'Achieve It.'\"",
            },
            {
                text: `${friendName} says, “Now, let’s practice the conversation.”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} says, \"Hi! I work at the snack shack. How can I help you?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} greet you and ask where the napkins are?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet me and ask where the napkins are.\"",
            },
            {
                text: `${friendName} says, \"Sure! The napkins are right by the drinks.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} respond to your answer with good manners?`,
                type: "question",
                sender: "friend",
                reminder: "Say, “Remember to respond to my answer with good manners.”",
            },
            {
                text: `${friendName} closes the conversation.`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} says, “Good job! You completed the Chat Challenge!”`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Now show ${studentName} the screen to get their final score.`,
                type: "instruction",
                sender: "friend"
            }
        ],

        // 7: Community Locations
        7: [
            {
                text: `${friendName} says, \"If you are at the clothing store to buy new socks for yourself and you don't know where they are, what is the first step to care for yourself?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "See It"?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"The first step is, 'See It.'\"",
            },
            {
                text: `${friendName} asks, \"What problem do you see?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "I don't know where the socks are in the store."?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember that you don't know where the socks are in the store.\"",
            },
            {
                text: `${friendName} asks, \"What is the second step to care for yourself?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "Fix It"?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"The second step is, 'Fix It.'\"",
            },
            {
                text: `${friendName} asks, \"How would you fix this problem?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "I will ask a worker for help."?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask a worker for help.\"",
            },
            {
                text: `${friendName} asks, \"What is the third step to care for yourself?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say, "Make It Better"?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"The third step is, 'Make It Better.'\"",
            },
            {
                text: `${friendName} asks, \"What can you say or do for the worker who helped you find the socks?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} say something nice?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to say or do something nice for the worker.\"",
            },
            {
                text: `${friendName} says, \"Now, let's practice having a conversation using good manners.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `${friendName} says, \"Hi! I work at a clothing store. How can I help you?\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} greet the worker and ask where the socks are while using good manners? (Please)`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet the worker and use good manners when asking where the socks are.\"",
            },
            {
                text: `${friendName} says, \"The socks are on the first aisle on your left.\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} respond using good manners? (Thank you)`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond using good manners.\"",
            },
            {
                text: `${friendName} says, \"You're welcome. Have a good day!\"`,
                type: "instruction",
                sender: "friend"
            },
            {
                text: `Did ${studentName} close the conversation?`,
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to close the conversation.\"",
            },
            {
                text: `${friendName} says, “Good job! You completed the Chat Challenge!”`,
                type: "instruction",
                sender: "friend"
            },            
            {
                title: "Step 1: How I Act",
                text: `Did ${studentName} use the 5 foundational skills (eye contact, listening, smile, posture, distance)?`,
                type: "question",
                sender: "friend",
            },
            {
                title: "Step 2: What I Say",
                text: `Did ${studentName} use kind words?`,
                type: "question",
                sender: "friend",
            },
            {
                title: "Step 3: How I say it",
                text: `Did ${studentName} talk in a calm voice?`,
                type: "question",
                sender: "friend",
            },
            {
                text: `Now show ${studentName} the screen to get their final score.`,
                type: "instruction",
                sender: "friend"
            }
        ]
    };

    return flows[conversationNum] || flows[0];
};

